/**
 * ThinkingText component displays animated text with a sweeping gradient effect.
 * Used to indicate loading or processing states in the chat interface.
 */

interface ThinkingTextProps {
  /** The text to display with the gradient animation */
  text?: string;
  /** Additional CSS classes to apply */
  className?: string;
}

/**
 * A component that displays text with a sweeping gradient animation.
 * The gradient sweeps from left to right continuously to indicate activity.
 *
 * @param props - The component props
 * @returns A span element with animated gradient text
 */
export function ThinkingText({ text = 'Thinking...', className = '' }: ThinkingTextProps) {
  return (
    <span
      className={`bg-gradient-to-r from-zinc-300 via-foreground to-zinc-300 bg-[length:200%_100%] bg-clip-text text-transparent animate-text-thinking ${className}`}
    >
      {text}
    </span>
  );
}
